import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${article.title} - P站视频指南`}
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
            {article.categoryName}
          </span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <h3
          className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-400">
              <i className="ri-eye-line mr-1"></i>
              {article.views.toLocaleString()}
            </span>
            <span className="text-xs text-foreground-400">
              <i className="ri-time-line mr-1"></i>
              {article.publishDate}
            </span>
          </div>
          <span className="text-xs text-primary-500 font-medium group-hover:translate-x-1 transition-transform whitespace-nowrap">
            阅读更多 →
          </span>
        </div>
      </div>
    </Link>
  );
}